export default __webpack_public_path__ + "static/media/goshen31.a7bbd6e7.jpg";